import { Directive, OnInit, OnDestroy, Input, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[scsPreventDefault]'
})
export class PreventDefaultDirective implements OnInit, OnDestroy {
  @Input('scsStopPropagation')
  eventName: string;

  private unlisten: Function;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.unlisten = this.renderer.listen(this.el.nativeElement, this.eventName || 'click', (event: Event) => {
      event.preventDefault();
    });
  }

  ngOnDestroy() {
    this.unlisten();
  }
}
